module.exports = __webpack_public_path__ + "img/fullscreen-open.c00d10de.svg";